import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

interface ContentCardCollapse{
    titulo: string;
    parrafo1: string;
    parrafo2?: string;
    parrafo3?: string;
    parrafo4?: string;
    imagen1?: string;
    imagen2?: string;
    imagen3?: string;
    imagen4?: string;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function CardCollapse(props:ContentCardCollapse) {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card >
      <CardActions disableSpacing>
        <CardHeader title={props.titulo} />
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </ExpandMore>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph>
            {props.parrafo1}
          </Typography>          
           {props.imagen1 ? <CardMedia
            component="img"
             image={props.imagen1}
             alt="img1"
           /> : <></>}
          <Typography paragraph>
            {props.parrafo2}
          </Typography>
          {props.imagen2 ? <CardMedia
            component="img"
             image={props.imagen2}
             alt="img2"
           /> : <></>}
          <Typography paragraph>
            {props.parrafo3}
          </Typography>
          {props.imagen3 ? <CardMedia
            component="img"
             image={props.imagen3}
             alt="img3"
           /> : <></>}
          <Typography>
           {props.parrafo4}
          </Typography>
          {props.imagen4 ? <CardMedia
            component="img"
             image={props.imagen4}
             alt="img4"
           /> : <></>}
        </CardContent>
      </Collapse>
    </Card>
  );
}